/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SGN, SGNInterface } from "../SGN";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract Staking",
        name: "_staking",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "depositId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "oldAddr",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newAddr",
        type: "bytes",
      },
    ],
    name: "SgnAddrUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "drainToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "sgnAddrs",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "staking",
    outputs: [
      {
        internalType: "contract Staking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_sgnAddr",
        type: "bytes",
      },
    ],
    name: "updateSgnAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_withdrawalRequest",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "withdrawnAmts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SGNConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: SGNConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SGN__factory extends ContractFactory {
  constructor(...args: SGNConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SGN";
  }

  deploy(_staking: string, overrides?: Overrides & { from?: string | Promise<string> }): Promise<SGN> {
    return super.deploy(_staking, overrides || {}) as Promise<SGN>;
  }
  getDeployTransaction(
    _staking: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_staking, overrides || {});
  }
  attach(address: string): SGN {
    return super.attach(address) as SGN;
  }
  connect(signer: Signer): SGN__factory {
    return super.connect(signer) as SGN__factory;
  }
  static readonly contractName: "SGN";
  public readonly contractName: "SGN";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SGNInterface {
    return new utils.Interface(_abi) as SGNInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): SGN {
    return new Contract(address, _abi, signerOrProvider) as SGN;
  }
}
